const API_URL = process.env.REACT_APP_API_URL;
import BaseApi from './baseApi';

class UserApi extends BaseApi {
  constructor() {
    super();
    this.baseUrl = '/users';
    this.pvsUrl = '/pvs';
    this.baseAwardUrl = '/awards';
    this.baseLuckyDrawUrl = '/lucky-draw-users';
  }

  fetchUser(token, userData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-user-list`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: userData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }
  getAwardUser(token, userData) {
    const endPoint = `${API_URL}${this.baseAwardUrl}/get-awards-users`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: userData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }
  getLuckyDrawUser(token, userData) {
    const endPoint = `${API_URL}${this.baseLuckyDrawUrl}/get-lucky-draw-user`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: userData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  createUser(token, userData) {
    const endPoint = `${API_URL}${this.baseUrl}/add-user`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: userData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  updateUser(userData, token) {
    const endPoint = `${API_URL}${this.baseUrl}/update-user-profile-for-bazaar`;
    const axiosRq = {
      url: endPoint,
      data: userData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

    getProductList(pageData, token) {
    const endPoint = `${API_URL}${this.pvsUrl}/get-product-list`;
    const axiosRq = {
      url: endPoint,
      data: pageData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  deleteUser(token, categoryId) {
    const endPoint = `${API_URL}${this.baseUrl}/delete-user/${categoryId}`;
    const axiosRq = {
      url: endPoint,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  getUserDetails(token, userData) {
    const endPoint = `${API_URL}${this.baseUrl}/get-user-details`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: userData,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  getSystemUserList(token) {
    const endPoint = `${API_URL}${this.baseUrl}/get-system-user-list`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  addSystemUser(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/add-system-user`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  editSystemUser(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-system-user`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }

  removeSystemUser(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/remove-system-user`;
    const axiosRq = {
      url: endPoint,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    return this.fetchData(axiosRq);
  }
}

const userApi = new UserApi();

export default userApi;
